import * as firebase from 'firebase';
import 'firebase/firestore';
import api from './utils/api';
import store from './store';

import { STAKE_UPDATING } from './App/rootReducer';

var config = {
  apiKey: 'AIzaSyARfF5u8yia3AqPgC6cJb9137Z_oLSW008',
  authDomain: 'staker-app.firebaseapp.com',
  databaseURL: 'https://staker-app.firebaseio.com',
  projectId: 'staker-app',
  storageBucket: 'staker-app.appspot.com',
  messagingSenderId: '201635474453'
};

export const initialiseFirebase = async accessToken => {
  try {
    const response = await api.getFirebaseToken(accessToken);
    signIn(response.data.firebaseToken);
  } catch (e) {
    console.error(e);
  }
};

const signIn = token => {
  console.log('Firebase sign in with custom token', token);
  firebase
    .auth()
    .signInWithCustomToken(token)
    .catch(function(error) {
      console.error('Firebase signin error: ', error.code, error.message);
    });
};

export const deleteStake = (id) => {
  return firebase
    .firestore()
    .collection('stakes')
    .doc(id)
    .delete()
    .then(() => {
      console.log('Stake deleted', id);
    })
    .catch(error => {
      console.error('Error deleting document: ', error);
    });
}

export const addStake = async (newStake, id) => updateStake(newStake, id, true);

export const updateStake = async (newStake, id, addStake) => {
  store.dispatch({type:STAKE_UPDATING});
  // Cleanse viewProps
  delete newStake.id;
  delete newStake.isMyStake;
  
  newStake.lastUpdated = Date.now();
  
  const collection = firebase
    .firestore()
    .collection('stakes')

  const promise = addStake ? collection.add(newStake) : collection.doc(id).update(newStake);

  return promise.then(() => {
    console.log('Firebase: Stake Updated', id, newStake.status);
  });
};

export const signOut = () => {
   firebase.auth().signOut().then(function() {
   }).catch(function(error) {
     // An error happened.
   });
 }

// const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export default firebase.firestore();



// WEBPACK FOOTER //
// ./src/firebase.js